module.exports = __webpack_public_path__ + "img/xgh2.ab6a2b63.jpg";